import type { RouteObject as AdminRouteObject } from "react-router-dom";
import type { AdminDashboardDependencies } from "../composition/create-admin-dashboard-dependencies";
import { DeviceKpiScreen } from "../../features/device-kpis/device-kpi-screen";

export function createDeviceKpisRoute(dependencies: AdminDashboardDependencies): AdminRouteObject {
  return {
    path: "device-kpis",
    element: <DeviceKpiScreen dependencies={dependencies} />,
  };
}
